import { http } from "../_apiConfig/http";
import { ApiRoutes } from "../routes/apiRoutes";

export const FloorMapService = {
  AddDevicePosition, getDeviceWithSensor, getFloorDetails, registerFloor, updateFloor, getFloorList,
  getSingleFloor,getFloorsBySite
};

function AddDevicePosition(id, data) {
  return http.update(`${ApiRoutes.FloorMapAddDevice}/${id}`, data, true);
}

function getDeviceWithSensor(data) {
  return http.post(`${ApiRoutes.DeviceWithSensor}`, data, true);
}

function getFloorDetails(floorId) {
  return http.get(`${ApiRoutes.getFloorList}/${floorId}`, true);
}

function registerFloor(data) {
  return http.post(`${ApiRoutes.getFloorList}`, data, true);
}

function updateFloor(floorId, data) {
  return http.update(`${ApiRoutes.getFloorList}/${floorId}`, data, true);
}

function getFloorList(page, limit, status) {
  return http.get(
    `${ApiRoutes.getFloorList}?page=${page}&limit=${limit}&status=${status}`,
    true
  );
}

function getSingleFloor(gatewayMac) {
  return http.get(
    `${ApiRoutes.getFloorList}/location/${encodeURIComponent(gatewayMac)}`,
    true
  );
}

function getFloorsBySite(page, limit, siteId) {
  return http.get(
    `${ApiRoutes.getFloorList}/site/${siteId}?page=${page}&limit=${limit}`,
    true
  );
}
